import { MAKER_WORLDS } from "@/data/maker";

const TAGS = ["wcag2a", "wcag2aa", "wcag21a", "wcag21aa", "wcag22aa"];
const STATIC = ["/", "/about", "/services", "/gallery", "/studio", "/reels", "/contact", "/accessibility",
  "/maker", "/kingsley", "/kingsley/fitting", "/payment/cancel", "/admin/login"];

export function sitePaths(catalog) {
  return [
    ...STATIC,
    ...MAKER_WORLDS.map((w) => `/maker/${w.id}`),
    ...(catalog?.categories || []).map((c) => `/kingsley/c/${c.id}`),
    ...(catalog?.products || []).map((p) => `/kingsley/p/${p.id}`),
  ];
}

const wait = (ms) => new Promise((r) => setTimeout(r, ms));

function loadInto(frame, path) {
  return new Promise((resolve) => {
    const done = () => { frame.removeEventListener("load", done); resolve(); };
    frame.addEventListener("load", done);
    frame.src = path;
    setTimeout(resolve, 15000);
  });
}

async function scanOne(frame, path) {
  await loadInto(frame, path);
  await wait(3500);
  const win = frame.contentWindow;
  const doc = frame.contentDocument;
  win.scrollTo(0, doc.body.scrollHeight);
  await wait(1200);
  win.scrollTo(0, 0);
  await wait(600);
  if (!win.axe) {
    await new Promise((resolve) => {
      const s = doc.createElement("script");
      s.src = "/axe.min.js";
      s.onload = resolve;
      s.onerror = resolve;
      doc.head.appendChild(s);
    });
  }
  const res = await win.axe.run(doc, { runOnly: { type: "tag", values: TAGS } });
  return res.violations.map((v) => ({
    id: v.id, impact: v.impact || "", help: v.help, help_url: v.helpUrl, count: v.nodes.length,
    targets: v.nodes.slice(0, 10).map((n) => n.target.join(" ").slice(0, 300)),
  }));
}

// Loads each page of the site in a hidden frame and runs the axe-core WCAG 2.2 AA rules on it.
export async function scanSite(paths, onProgress) {
  const frame = document.createElement("iframe");
  frame.setAttribute("aria-hidden", "true");
  frame.tabIndex = -1;
  frame.title = "Accessibility scan";
  Object.assign(frame.style, { position: "fixed", left: "-12000px", top: "0", width: "1280px", height: "900px", border: "0" });
  document.body.appendChild(frame);
  const pages = [];
  try {
    for (let i = 0; i < paths.length; i++) {
      onProgress?.(i, paths.length, paths[i]);
      try {
        pages.push({ path: paths[i], violations: await scanOne(frame, paths[i]) });
      } catch (e) {
        pages.push({ path: paths[i], violations: [], error: String(e?.message || e).slice(0, 300) });
      }
    }
  } finally {
    frame.remove();
  }
  return pages;
}
